import { TwSolicitudJerarquiaViewModel } from "../datosbasicos/datosbasicos.types";
import { TwInspeccionRechazoViewModel } from "../inspecciones/inspecciones.types";

export class SolicitudAnulacionViewModel {
    public Id: number;
    public IdEstadoSolicitud = 0;
    public IdEstadoSolicitudDescripcion: string;
    public IdTipoSolicitud: number;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public CodigoTraces = "";
    public EsPredua: boolean;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public TAnulacion: TAnulacionSolicitudViewModel;
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
    public TwInspeccionRechazo: TwInspeccionRechazoViewModel;
}

export class TAnulacionSolicitudViewModel {
    public Id: number;
    public IdSolicitud: number;
    public IdUsuario: number;
    public NombreUsuario = "";
    public Observaciones = "";
    public Fecha: Date;
}
